import React from 'react';
import { renderGapSubStepNavButton } from '../gapSubStepNavUi';
import './page.css';

/**
 * Map a legacy `{key,label,num}` list plus lock/complete/badge/attention lookups to SubStepNav steps.
 */
export const buildSubSteps = (substeps, { lockedKeys, completedKeys, badgeByKey, attentionTitleByKey } = {}) =>
  substeps.map((s) => ({
    ...s,
    locked: !!(lockedKeys && lockedKeys.has(s.key)),
    completed: !!(completedKeys && completedKeys.has(s.key)),
    badgeCount: (badgeByKey && badgeByKey[s.key]) || 0,
    attentionTitle: attentionTitleByKey ? attentionTitleByKey[s.key] : undefined,
  }));

/**
 * Second-level (in-stage) navigation. steps: [{ key, label, num?, locked?, completed?,
 * attentionTitle?, badgeCount?, lockedHint? }]. States follow the shared pill visuals.
 * variant: 'default' | 'compact' | 'onDark'. onSelect(key) fires for unlocked steps only.
 */
const SubStepNav = ({ steps = [], activeKey, onSelect, variant = 'default', compact, ariaLabel = 'Sections', className = '' }) => {
  const isCompact = compact ?? (variant === 'compact' || variant === 'onDark');
  return (
  <nav
    className={`pl-substep-nav pl-substep-nav--${variant} ${className}`.trim()}
    aria-label={ariaLabel}
    data-testid="substep-nav"
  >
    {steps.map((s, i) =>
      renderGapSubStepNavButton(
        { key: s.key, label: s.label, num: s.num ?? i + 1 },
        {
          isLocked: !!s.locked,
          isActive: s.key === activeKey,
          isCompleted: !!s.completed,
          badgeCount: s.badgeCount,
          // An attention dot only makes sense on a step the user can still act on.
          attentionTitle: !s.locked && !s.completed ? s.attentionTitle : null,
          lockedHint: s.lockedHint,
          compact: isCompact,
          onSelect: (k) => onSelect && onSelect(k),
        },
      ),
    )}
  </nav>
  );
};

export default SubStepNav;
